// **** import modules ****
import $ from "jquery";
import app, { csl } from "@@assets/scripts/common";
import otukuriVideoSrc from "./video/otukuri.mp4";
import otukuriPoster from "./images/otukuri-poster.jpg";

// **** process ****
app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
	
	initOthkuriVideo();
});

async function initOthkuriVideo() {
	const $video = $("#otukuri_video");
	if(!$video.length) {
		return false;
	}
	
	$video.attr({
		src: otukuriVideoSrc,
		poster: otukuriPoster
	});
	
	return true;
}

app.exec();
